<template>
    <swiper :options="swiperOption" ref="mySwiper">

        <!-- slides -->
        <swiper-slide v-for="carouselItem in carouselItems" :key="`slide-${carouselItem.id}`">
            <div class="slide-image">
                <img :src="carouselItem.image_url" alt="" />
                <div class="slide-content">
                    <h2 class="slide-title">{{ carouselItem.title }}</h2>
                    <div v-html="carouselItem.short_text"></div>
                    <a :href="carouselItem.link" v-if="carouselItem.link_label" class="btn btn-primary">{{ carouselItem.link_label }}</a>
                </div>
            </div>
        </swiper-slide>

        <!-- Optional controls -->
        <div class="swiper-pagination" slot="pagination"></div>
        <!-- <div class="swiper-button-prev" slot="button-prev"></div> -->
        <!-- <div class="swiper-button-next" slot="button-next"></div> -->
        <!-- <div class="swiper-scrollbar" slot="scrollbar"></div> -->

    </swiper>
</template>

<script>
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';

export default {
    components: {
        swiper,
        swiperSlide,
    },
    props: ['carouselItems'],
    data () {
        return {
            swiperOption: {
                keyboard: true,
                autoHeight: true,
                spaceBetween: 200,
                centeredSlides: true,
                slidesPerView: 'auto',
                a11y: true,
                breakpoints: {
                    768: {
                        spaceBetween: 50
                    },
                },
                pagination: {
                    el: '.swiper-pagination',
                    dynamicBullets: true,
                    clickable: true
                },
                autoplay: {
                    delay: 9000,
                    disableOnInteraction: true,
                },
                on: {
                    lazyImageReady: this.updateAutoHeight
                },
            },
        };
    },
    computed: {
        swiper () {
            return this.$refs.mySwiper.swiper;
        },
    },
    methods: {
        updateAutoHeight () {
            this.swiper.updateAutoHeight();
        },
    },
};
</script>

<style lang="scss" scoped>
.swiper-container {
    // Largeur slide + Largeur box - Overlap
    max-width: (950px + 300px - 80px);
}
.slide-image {
    max-width: 950px;
    @include breakpoint(medium) {
        margin-right: 200px;
    }
    img {
        @include breakpoint(medium) {
            object-fit: cover;
            min-height: 400px;
        }
    }
}
.slide-title {
    @include rem-typo(22px, 30px);
    font-family: $f-oswald;
    text-transform: uppercase;
    font-weight: 700;
}
.slide-content {
    padding: 1rem;
    background: $white;
    color: $black;
    box-shadow: 0px 0px 13px 3px transparentize($black, 0.92);
    max-width: 85%;
    margin: 0 auto;
    transform: translateY(-24px);
    @include breakpoint(medium) {
        position: absolute;
        transform: translateY(-50%);
        right: 0;
        top: 50%;
        padding: 35px;
        max-width: 300px;
        box-sizing: border-box;
        margin-right: 8px;
        margin-top: 0;
    }
    div {
        @include rem-typo(14px);
        font-weight: 700;
        color: $c-dim-text;
    }
}
.btn {
    margin-top: 1rem;
}
</style>
<style lang="scss">
.swiper-container-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
    position: static;
    transform: none;
    margin: 10px auto;
}
.swiper-pagination {
    .swiper-pagination-bullet {
        width: 18px;
        height: 18px;
    }
    .swiper-pagination-bullet-active {
        background: $c-atelier;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/utils/BmrSwiper.vue